var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInternetExplorer)?_c('div',{staticClass:"alert alert-warning my-0 fixed bottom-0 left-0 right-0 z-9999",attrs:{"role":"alert"}},[_vm._v("\n    We’ve detected that you may be using an outdated, unsupported web browser. Please upgrade to a modern web browser for the best RSVPify experience.\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }